// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lA28","top":"styles_top__hdtNt","left":"styles_left__pIvLa","description":"styles_description__2T1Rr"};